import { Ignore } from '@master/annotation/Ignore'
import { RawKey } from '@master/annotation/RawKey'
import { Meta } from '@master/model/common/Meta'

export class BscRecordMeta extends Meta {
  @RawKey('_oid')
  oid = ''

  @Ignore()
  reviewOid = ''

  userOid = ''
  reviewYear: number = undefined
  reviewQuarter: number = undefined
  bscGrade = ''
  isauReviewer = ''
  dateCompleted: number = undefined
  cat1InfractionTotal: number = undefined
  cat2InfractionTotal: number = undefined
  adminErrorTotal: number = undefined
  company = ''
  ctm: number = undefined
  dateCreated: number = undefined
  pky: number = undefined

  @Ignore()
  previousRecordOid = ''
}

export class SupervisorGradeMeta extends Meta {
  reviewQuarter: number
  reviewYear: number
  bscGrade: number
}
